<template>
  <BModal v-bind="$attrs"
          ref="modal"
          :size="size"
          :title-tag="titleTag"
          :hide-header-close="shouldHideHeaderClose"
          :no-close-on-backdrop="true"
          @close="close">
    <template v-if="$slots['modal-header']"
              #modal-header="scopedProperties">
      <slot name="modal-header"
            v-bind="scopedProperties"
            :title="title">
      </slot>
      <Icon v-if="shouldUseMaterializedCrossForModalHeader && !shouldHideHeaderClose"
            class="close-x"
            name="cross2"
            title="close"
            @click="close"></Icon>
    </template>
    <template #modal-title="scopedProperties">
      <slot name="modal-title"
            v-bind="scopedProperties"
            :title="title">
        {{ title }}
      </slot>
      <Badge v-if="titleBadge !== ''"
             :text="titleBadge"
             class="ml-3">
      </Badge>
    </template>
    <slot></slot>
    <template #modal-footer="scopedProperties">
      <div v-loading="isLoading">
        <slot name="modal-footer"
              v-bind="scopedProperties">
        </slot>
      </div>
    </template>
  </BModal>
</template>

<script>
  import { BModal } from 'bootstrap-vue';
  import Icon from '@common/layout/Icon.vue';
  import Badge from './Badge.vue';
  import translator from '~/zf/frontend/common/mixins/translator';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';

  export default {
    name: 'Modal',
    compatConfig: {
      MODE: 3,
    },
    components: {
      Icon,
      Badge,
      BModal,
    },
    mixins: [translator],
    model: {
      prop: 'visible',
      event: 'change',
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      titleBadge: {
        type: String,
        default: '',
      },
      titleTag: {
        type: String,
        default: 'h1',
      },
      size: {
        type: String,
        default: BootstrapVariant.MEDIUM,
        validator(size) {
          return [
            BootstrapVariant.SMALL,
            BootstrapVariant.MEDIUM,
            BootstrapVariant.LARGE,
            BootstrapVariant.XLARGE,
            BootstrapVariant.XXLARGE,
            BootstrapVariant.MAX,
          ].includes(size);
        },
      },
      shouldHideHeaderClose: {
        type: Boolean,
        default: true,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      preventDefaultClose: {
        type: Boolean,
        default: false,
      },
      shouldUseMaterializedCrossForModalHeader: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['close'],
    expose: ['show', 'hide'],
    data() {
      return {
        BootstrapVariant,
      };
    },
    methods: {
      show() {
        this.$refs.modal.show();
      },
      hide() {
        this.$refs.modal.hide();
      },
      close(closeEvent) {
        if (this.preventDefaultClose) {
          closeEvent.preventDefault();
        }
        this.$emit('close', closeEvent);
      },
    },
  };
</script>

<style scoped lang="scss">
  .close-x {
    font-size: 14px;
    cursor: pointer;
    padding-top: 10px;
    padding-right: 12px;
  }
</style>
